import React from "react";
import { useT } from "../lib/i18n";

const COLORS = {
  hotel: "#0A2540",
  food: "#D4AF37",
  transport: "#4FB3E8",
  shopping: "#15C3C6",
  tickets: "#7C6AE8",
  misc: "#94A3B8",
};

export default function BudgetCard({ budget }) {
  const { t } = useT();
  const total = budget.total || Object.entries(budget).filter(([k]) => k !== "total").reduce((s, [, v]) => s + Number(v || 0), 0);
  const items = Object.entries(budget)
    .filter(([k]) => k !== "total")
    .map(([k, v]) => ({ k, v: Number(v || 0), pct: total ? (Number(v || 0) / total) * 100 : 0 }));

  const labelFor = (k) => t(`budget.${k}`) || k;

  return (
    <div className="bg-white rounded-[1.5rem] p-5 md:p-6 shadow-[0_4px_24px_rgba(0,0,0,0.04)] border border-[#E8E8ED]" data-testid="budget-card">
      <div className="flex items-baseline justify-between">
        <div className="text-xs uppercase tracking-[0.15em] text-gray-500">{t("iv.estimated_budget")}</div>
        <div className="text-3xl font-semibold text-[#0A2540]">RM{total.toLocaleString()}</div>
      </div>
      <div className="mt-4 h-3 w-full bg-[#F5F5F7] rounded-full overflow-hidden flex">
        {items.map((it) => (
          <div key={it.k} style={{ width: `${it.pct}%`, background: COLORS[it.k] || "#94A3B8" }} title={`${labelFor(it.k)}: ${it.pct.toFixed(0)}%`} />
        ))}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mt-4">
        {items.map((it) => (
          <div key={it.k} className="flex items-center gap-2">
            <span className="w-2.5 h-2.5 rounded-full" style={{ background: COLORS[it.k] || "#94A3B8" }} />
            <div className="flex-1 min-w-0">
              <div className="text-xs text-gray-500">{labelFor(it.k)}</div>
              <div className="text-sm font-medium text-[#1D1D1F]">RM{it.v.toLocaleString()}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
